export default __webpack_public_path__ + "static/media/family.a6f88856.png";